<template>
  <el-tooltip
    :content="currentLabel"
    placement="bottom"
  >
    <el-button
      class="theme-toggle-btn"
      :class="{ 'unicorn-active': isUnicornMode }"
      circle
      @click="toggleTheme"
    >
      <Icon
        v-if="isUnicornMode"
        icon="mdi:unicorn"
        :width="20"
      />
      <Icon
        v-else-if="themeMode === 'dark'"
        icon="mdi:weather-night"
        :width="20"
      />
      <Icon
        v-else-if="themeMode === 'light'"
        icon="mdi:white-balance-sunny"
        :width="20"
      />
      <Icon
        v-else
        icon="mdi:monitor"
        :width="20"
      />
    </el-button>
  </el-tooltip>
</template>

<script setup>
import { computed } from "vue";
import { useTheme } from "@/composables/useTheme";
import { Icon } from '@iconify/vue';

const { toggleTheme, themeMode, isUnicornMode } = useTheme();

const modeLabels = {
    dark: "Mode sombre",
    light: "Mode clair",
    auto: "Auto (adapté au système)"
};

const currentLabel = computed(() => {
    if (isUnicornMode.value) return "Mode licorne 🦄 (cliquer pour désactiver)";
    return modeLabels[themeMode.value];
});
</script>

<style lang="scss" scoped>
.theme-toggle-btn {
    background-color: transparent;
    border: none;
    padding: 0;
    color: var(--app-text-secondary, #606266);

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
        color: var(--el-color-primary);
    }

    &.unicorn-active {
        animation: unicorn-glow 2s ease-in-out infinite;
        color: #c084fc !important;
    }
}

html.dark .theme-toggle-btn {
    color: var(--app-text-secondary);

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: #fbbf24;
    }
}



@keyframes unicorn-glow {
    0%, 100% { color: #c084fc; filter: drop-shadow(0 0 4px rgba(192, 132, 252, 0.6)); }
    33% { color: #f472b6; filter: drop-shadow(0 0 4px rgba(244, 114, 182, 0.6)); }
    66% { color: #60a5fa; filter: drop-shadow(0 0 4px rgba(96, 165, 250, 0.6)); }
}
</style>
